<div class="client-header">
  <div>
    @if (label) {
      <span class="mat-subtitle-1">{{label}}</span>
    }
  </div>
  <div>
    @if (client) {
      <span class="mat-subtitle-1">{{client.getNaam()}}</span>
    }
    @if (client) {
      <span> ({{client.getNummer()}})</span>
    }
  </div>
</div>
